module.exports = __webpack_public_path__ + "static/media/matilde-hat-greece-impressed.a2f572c6.png";